import React from 'react';
import loadCurators from 'bundle-loader?lazy&name=Home!./components/routes/curatorListPage/curatorListPage';
import loadAddEditCurators from 'bundle-loader?lazy&name=Home!./components/routes/addEditCurator/addEditCurator';

import { GOLD_COMPANY_ID } from './utils/constants';

const Bundle = ( Component, routeProps = {} ) => (
    ( props ) => (
        <Component { ...props } { ...routeProps } />
    )
);

// Custom parameters to use with `biw-web-router`.
const params = {
    uuid: ( paramName ) => `${ paramName ? ( ':' + paramName ) : '' }([a-z0-9]{8}-[a-z0-9]{4}-[a-z0-9]{4}-[a-z0-9]{4}-[a-z0-9]{12})`,
    // ...
};

export const COMPANY_ID = params.uuid( 'companyId' );
export const CURATOR_ID = params.uuid( 'curatorId' );

export const routes = {
    'home': {
        id: 0, // order
        title: 'Gantry Curator Studio',
        pattern: `/${ COMPANY_ID }?`,
        // No page to render at the moment
    },
    'curators': {
        id: 1,
        title: 'Gantry Curator Studio - Curators',
        pattern: `/${ COMPANY_ID }?/curators`,
        load: loadCurators
    },
    'addCurator': {
        id: 2,
        title: 'Gantry Curator Studio - Add Curators',
        pattern: `/${ COMPANY_ID }?/curators/create`,
        load: loadAddEditCurators
    },
    'editCurator': {
        id: 3,
        title: 'Gantry Curator Studio - Edit Curators',
        pattern: `/${ COMPANY_ID }?/curators/${ CURATOR_ID }`,
        load: loadAddEditCurators
    }

    // ...
};

// Build the list of routes to feed into the router.
export const routeList = Object.values( routes ).sort( ( a, b ) => ( a?.id || 0 ) - ( b?.id || 0 ) );

export function bundleRoutingMiddleware( action, nextRoute, prevRoute ) {
    const { match } = nextRoute;
    
    if ( match && !match.render && typeof match.load === 'function' ) {
        match.load( asyncModule => {
            match.render = Bundle(
                asyncModule.default ? asyncModule.default : asyncModule, match.props
            );
            action.ok();
        } );
    } else {
        action.ok();
    }
}

/**
 * Replaces variables found in a route pattern.
 *
 * @param { string } pattern - The pattern with variables to replace.
 * @param { object } vars - The data to use to replace variables found in the pattern.
 * @returns { string }
 */
export const replacePatternVars = ( pattern, vars ) => {
    const PATTERN_DELIMITER = '/';
    const pathTokens = ( pattern || '' ).split( PATTERN_DELIMITER ).filter( token => !!token );
    const resolvedTokens = [];
    
    // Attempt to resolve all tokens in the pattern
    for ( let i = 0; i < pathTokens.length; i++ ) {
        const token = pathTokens[ i ];
        const PATTERN_PARAM = /^:[a-zA-Z0-9]+/g;
        const paramMatches = ( token || '' ).match( PATTERN_PARAM );
        
        // If there is a parameter in the token and a matching value, replace the token.
        if ( paramMatches && paramMatches.length > 0 ) {
            const match = paramMatches[ 0 ];
            const paramName = match.substring( 1 );
            
            const value = vars[ paramName ];
            if ( value !== null && value !== undefined ) {
                resolvedTokens.push( value );
                continue;
            }
        }
        
        // If the token hasn't already been replaced, leave the token as is.
        resolvedTokens.push( token );
    }
    
    return PATTERN_DELIMITER + resolvedTokens.join( PATTERN_DELIMITER );
};

export const redirectMiddleware = [
    /**
     * If there is no company id in the URL, update the URL to include one defaulting to
     * the GOLD 000 company.
     */
    ( action, nextRoute, prevRoute ) => {
        const hasMatch = !!nextRoute?.match;
        if ( hasMatch ) {
            const companyId = nextRoute?.state?.params?.companyId;
            if ( !companyId ) {
                const pattern = nextRoute?.match?.pattern;
                const redirectPath = replacePatternVars( pattern, {
                    ...( nextRoute?.state?.params || {} ),
                    companyId: GOLD_COMPANY_ID
                } );

                return action.redirect( redirectPath );
            }
        }

        return action.ok();
    },

    /**
     * If on the root or Home page, redirect to the Curator List page since that is currently
     * acting as our main page in the studio.
     */
    ( action, nextRoute, prevRoute ) => {
        const hasMatch = !!nextRoute?.match;
        if ( hasMatch ) {
            const HOME_PAGE_PATTERN = `/${ COMPANY_ID }?`;
            const pattern = nextRoute?.match?.pattern;

            if ( HOME_PAGE_PATTERN === pattern ) {
                const GANTRY_CURATOR_LIST_PAGE_PATTERN = `/${ COMPANY_ID }?/curators`;
                const redirectPath = replacePatternVars( GANTRY_CURATOR_LIST_PAGE_PATTERN, {
                    companyId: GOLD_COMPANY_ID,
                    ...( nextRoute?.state?.params || {} ),
                } );

                return action.redirect( redirectPath );
            }
        }

        return action.ok();
    }

    //...
];
